import { useEffect, useState } from 'react'
import { Copy, Check, Store, Share2, Sparkles } from 'lucide-react'
import api from '../api/client'
import { useAuth } from '../auth'

function LinkCard({ titulo, descricao, url, msg, icon: Icon }) {
  const [copiado, setCopiado] = useState(false)
  const wa = `https://wa.me/?text=${encodeURIComponent(`${msg} ${url}`)}`
  function copiar() { navigator.clipboard?.writeText(url); setCopiado(true); setTimeout(() => setCopiado(false), 1500) }
  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
      <p className="font-medium text-gray-900 flex items-center gap-2">{Icon && <Icon size={16} className="text-accent-600" />}{titulo}</p>
      <p className="text-xs text-gray-500 mb-3">{descricao}</p>
      <div className="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2 text-sm break-all border border-gray-100">
        <span className="flex-1">{url}</span>
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        <button onClick={copiar} className="flex items-center gap-1.5 rounded-lg bg-graphite text-white px-3 py-1.5 text-sm">
          {copiado ? <><Check size={14} /> Copiado!</> : <><Copy size={14} /> Copiar</>}
        </button>
        <a href={wa} target="_blank" rel="noreferrer" className="rounded-lg bg-accent-500 text-white px-3 py-1.5 text-sm">Enviar no WhatsApp</a>
        <a href={url} target="_blank" rel="noreferrer" className="rounded-lg border border-gray-200 px-3 py-1.5 text-sm text-gray-700">Abrir</a>
      </div>
    </div>
  )
}

export default function MeuLink() {
  const { lojaHabilitada } = useAuth()
  const [cod, setCod] = useState(null)
  const [base, setBase] = useState('https://ev.theconect.com.br/#/loja')
  const [ofertas, setOfertas] = useState([])
  const [sel, setSel] = useState([])         // ids selecionados (vazio = todos)
  const [cliente, setCliente] = useState('') // nome do cliente p/ saudação (opcional)

  useEffect(() => {
    const lic = JSON.parse(localStorage.getItem('licenciado') || 'null')
    if (lic?.codigo_indicacao) setCod(lic.codigo_indicacao)
    else api.get('/auth/me').then((r) => setCod(r.data?.licenciado?.codigo_indicacao)).catch(() => {})
    api.get('/parametros-mlm').then((r) => r.data?.loja_base_url && setBase(r.data.loja_base_url)).catch(() => {})
    api.get('/ofertas/publico').then((r) => setOfertas(r.data || [])).catch(() => {})
  }, [])

  if (!cod) {
    return (
      <div>
        <h1 className="text-2xl font-heading font-bold text-gray-900 mb-2">Meu Link / Loja</h1>
        <p className="text-gray-500">Seu usuário não está vinculado a um licenciado com código de indicação.</p>
      </div>
    )
  }

  const lojaUrl = `${base}/${cod}`
  const origin = base.replace(/\/loja$/, '')
  const recrutamentoUrl = `${origin}/negocio/${cod}`   // NOVO LICENCIADO -> checkout de licença (ASAAS)
  const clienteUrl = `${origin}/cliente/${cod}`         // NOVO CLIENTE -> cadastro (sem pagamento)
  const simuladorUrl = `${origin}/simulador/${cod}`     // SIMULADOR público (economia) vinculado a você

  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]))
  const qs = []
  if (sel.length) qs.push(`o=${sel.join(',')}`)
  if (cliente.trim()) qs.push(`c=${encodeURIComponent(cliente.trim())}`)
  const vitrineUrl = `${lojaUrl}${qs.length ? '?' + qs.join('&') : ''}`

  return (
    <div className="max-w-3xl space-y-5">
      <div>
        <h1 className="text-2xl font-heading font-bold text-gray-900">{lojaHabilitada ? 'Meu Link / Loja' : 'Meus Links'}</h1>
        <p className="text-gray-500 text-sm">Seu código: <span className="font-semibold text-accent-600">{cod}</span> · toda venda/indicação fica vinculada a você (PV + comissão).</p>
      </div>

      {/* ── LINKS DE SERVIÇO — sempre disponíveis (independem da Loja de produtos físicos) ── */}
      <LinkCard icon={Sparkles} titulo="Seja um Licenciado (recrutamento)"
        descricao="Para recrutar um NOVO LICENCIADO. Ele preenche os dados básicos e vai direto ao pagamento da licença (PIX, cartão ou boleto via ASAAS). A licença é ativada após a confirmação."
        url={recrutamentoUrl} msg="Seja um Licenciado The Conect pelo meu link:" />

      <LinkCard icon={Sparkles} titulo="Simulador de economia (energia)"
        descricao="O cliente informa a conta de luz e vê a economia estimada. A simulação fica registrada no seu painel (Minhas Simulações), vinculada a você."
        url={simuladorUrl} msg="Simule sua economia de energia com a The Conect:" />

      <LinkCard icon={Share2} titulo="Indicar Cliente"
        descricao="Para cadastrar um NOVO CLIENTE vinculado ao seu código (sem pagamento de licença)."
        url={clienteUrl} msg="Faça seu cadastro na The Conect pelo meu link:" />

      {/* ── LINKS DA LOJA — só quando a Loja de Produtos Físicos está HABILITADA ── */}
      {lojaHabilitada ? (
        <>
          <LinkCard icon={Store} titulo="Loja completa"
            descricao="O cliente vê todos os produtos/serviços disponíveis, monta o carrinho e paga. A venda fica vinculada a você (PV + comissão)."
            url={lojaUrl} msg="Confira minha loja The Conect:" />

          {/* Vitrine personalizada (Link Personalizado da Loja) */}
          <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
            <p className="font-medium text-gray-900 flex items-center gap-2"><Sparkles size={16} className="text-accent-600" /> Vitrine personalizada</p>
            <p className="text-xs text-gray-500 mb-3">Escolha os produtos/serviços que o cliente verá ao abrir o link. Sem seleção = todos.</p>

            <div className="flex items-center gap-2 mb-2">
              <button onClick={() => setSel([])} className={`text-xs px-2.5 py-1 rounded-lg border ${sel.length === 0 ? 'bg-accent-500 text-white border-accent-500' : 'border-gray-200 text-gray-600'}`}>Todos</button>
              <button onClick={() => setSel(ofertas.map((o) => o.id))} className="text-xs px-2.5 py-1 rounded-lg border border-gray-200 text-gray-600">Selecionar tudo</button>
              {sel.length > 0 && <span className="text-xs text-gray-400">{sel.length} selecionado(s)</span>}
            </div>

            <div className="grid sm:grid-cols-2 gap-2 max-h-64 overflow-y-auto tc-scroll mb-3">
              {ofertas.map((o) => (
                <label key={o.id} className={`flex items-center gap-2 border rounded-lg px-3 py-2 text-sm cursor-pointer ${sel.includes(o.id) ? 'border-accent-300 bg-accent-50/40' : 'border-gray-200'}`}>
                  <input type="checkbox" checked={sel.includes(o.id)} onChange={() => toggle(o.id)} className="w-4 h-4 accent-accent-500" />
                  {o.imagem_url && <img src={o.imagem_url} alt="" className="w-8 h-8 rounded object-cover" />}
                  <span className="flex-1 min-w-0">
                    <span className="block truncate text-gray-800">{o.nome}</span>
                    <span className="text-[11px] text-gray-400">{o.tipo} · R$ {Number(o.preco || 0).toFixed(2)} · {o.pv} PV</span>
                  </span>
                </label>
              ))}
              {ofertas.length === 0 && <p className="text-sm text-gray-400">Nenhuma oferta disponível.</p>}
            </div>

            <div className="mb-3">
              <label className="block text-xs font-medium text-gray-600 mb-1">Para o cliente (opcional — aparece uma saudação)</label>
              <input value={cliente} onChange={(e) => setCliente(e.target.value)} placeholder="Ex.: João"
                className="w-full sm:w-72 border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400" />
            </div>

            <LinkCard icon={Sparkles} titulo="Link da vitrine"
              descricao={sel.length ? `${sel.length} item(ns) selecionado(s).` : 'Todos os itens.'}
              url={vitrineUrl} msg={cliente ? `Olá ${cliente}, separei isto pra você:` : 'Separei isto pra você:'} />
          </div>
        </>
      ) : (
        <p className="text-xs text-gray-400 border border-dashed border-gray-200 rounded-xl px-4 py-3">
          A Loja de produtos físicos está desativada no momento — seus links de serviço acima continuam ativos e vinculados a você.
        </p>
      )}
    </div>
  )
}
